import { render, staticRenderFns } from "./maritalstatusform.vue?vue&type=template&id=38ae961b&"
import script from "./maritalstatusform.vue?vue&type=script&lang=js&"
export * from "./maritalstatusform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports